import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'irembogov-rich-editor',
  templateUrl: './custom-rich-editor.component.html',
})
export class CustomRichEditorComponent extends FieldType {
  constructor() {
    super();
  }
  quillConfig = {
    toolbar: [['bold', 'italic', 'underline'], ['link']],
  };
}
